import Yup from "../yup";

const incidentDetailsValid = (value: string) => {
    if (!value) return false;
    return value.trim() !== 'The respondent has';
}

const incidentDetails = [
    "phy",
    "pys",
    "aep",
    "cym",
    "thy",
    "cbp",
    "fsw",
    "dyp",
    "ryf",
    "htc",
    "kha",
    "sty",
    "fmc",
    "cdw",
  ].reduce(
    (children, incidentKey) => {
      return {
        ...children,
  
        [`incident_${incidentKey}_date`]: Yup.string().when(
          ["seeking", `app_type_extend_why`, `incident_${incidentKey}_detail`],
          {
            is: (seeking: string, app_type_extend_why: string[], incident_detail: string) =>
              seeking === "appl" && Array.isArray(app_type_extend_why)
              && app_type_extend_why.includes('further_violence') && incidentDetailsValid(incident_detail),
            then: Yup.string()
              .required('Please provide date or approximate date'),
          }
        ),
      };
    },
    {}
);

const yourCircumstances = {
    app_type_extend_why:  Yup.array().ensure().min(1, "Please select a reason for extending."),

    app_type_extend_why_still_fearful: Yup.string()
        .when(["seeking", "app_type_extend_why"], {
        is: (seeking: string, app_type_extend_why: string[]) =>
            seeking === "appl" && Array.isArray(app_type_extend_why) &&
            app_type_extend_why.includes("still_fearful"),
        then: Yup.string().required("We require this information"),
        }),
    app_type_extend_further_violence_check: Yup.string()
        .when(["seeking", "app_type_extend_why", "incident_phy_detail", "incident_pys_detail", "incident_aep_detail", "incident_cym_detail", "incident_thy_detail",
        "incident_cbp_detail", "incident_fsw_detail", "incident_dyp_detail", "incident_ryf_detail", "incident_htc_detail", "incident_kha_detail", "incident_sty_detail", "incident_fmc_detail",
        "incident_cdw_detail"], {
        is: (seeking: string, app_type_extend_why: string[], ...rest: any[]) =>
            seeking === "appl" && Array.isArray(app_type_extend_why) &&
            app_type_extend_why.includes("further_violence") && !rest.some(incidentDetailsValid),
        then: Yup.string().required("Please fill at least one section of allegations of further violence have occurred"),
        }),
    ...incidentDetails,
    app_type_extend_why_breached: Yup.string()
        .when(["seeking", "app_type_extend_why"], {
        is: (seeking: string, app_type_extend_why: string[]) =>
            seeking === "appl" && Array.isArray(app_type_extend_why) &&
            app_type_extend_why.includes("breached"),
        then: Yup.string().required("We require this information"),
        }),
    app_type_extend_why_violence_stopped: Yup.string()
        .when(["seeking", "app_type_extend_why"], {
        is: (seeking: string, app_type_extend_why: string[]) =>
            seeking === "appl" && Array.isArray(app_type_extend_why) &&
            app_type_extend_why.includes("violence_stopped"),
        then: Yup.string().required("We require this information"),
        }),
}

export default yourCircumstances;